import {Injectable} from '@angular/core';
import {ParentAPIService} from './parent.api.service';
import {HttpClient} from '@angular/common/http';
import {MessageService} from 'primeng/api';
import {Observable} from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

@Injectable({
  providedIn: 'root'
})
export class ToastService extends ParentAPIService {

  severity: string | undefined;
  dateToast: any;
  message: string | undefined;
  debugMessage: string | undefined;
  cause: string | undefined;
  isError: boolean | undefined;
  messageService: MessageService;
  dateToastChange: Observable<any> | undefined;

  constructor(http: HttpClient, messageService: MessageService,
              private translateService: TranslateService) {
    super(http);
    this.messageService = messageService;
  }

  addToastTranslationWithParameters(translation: string, messageParameters: object) {
    this.addToast(false, new Date().getMilliseconds(),
      this.translateService.instant('toast-service.toast.' + translation + '-message', messageParameters));
  }

  addToast(isError: boolean, timestamp: any, message: string, debugMessage?: string, cause?: string) {
    this.isError = isError;
    this.dateToast = timestamp;
    this.dateToastChange = new Observable(this.dateToast);
    this.message = message;
    if (cause !== '') {
      this.cause = cause;
    }
    let life = 3000;
    let sticky = false;
    this.severity = 'success';
    if (isError) {
      this.severity = 'error';
      // Keep error toasts on screen until dismissed so the support reference code
      // they carry can be read and copied from the toast.
      sticky = true;
    }
    const actualDate = new Date().getTime();
    const storeObject = {[actualDate]: {'debug': debugMessage, 'cause': cause}};

    localStorage.setItem('toast-service', localStorage.getItem('toast-service') !== null ?
      // @ts-ignore
      localStorage.getItem('toast-service').slice(0, -1) + ',' + JSON.stringify(storeObject).slice(1, -1) + '}' :
      JSON.stringify(storeObject));

    if (message)
    this.messageService.add({
      severity: this.severity,
      summary: message,
      data: {debug: debugMessage, time: timestamp, isOnError: isError, actualDate: actualDate, cause: cause},
      life: life,
      sticky: sticky,
      closable: true
    });

  }
}
